import {
  LOAD_TRUCKNOTUSE,
  LOAD_TRUCKNOTUSE_PREVIEW,
  LOAD_VEHICLE_TRUCKNOTUSE,
  LOAD_VEHICLE_TYPE_TRUCKNOTUSE,
} from './actions'

const initialState = {
  trucknotusekUrl: '',
  vehicleLists: [],
  vehicleTypeLists: [],
  trucknotuseLoading: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_TRUCKNOTUSE.REQUEST:
    case LOAD_TRUCKNOTUSE_PREVIEW.REQUEST:
      const { loading } = action.payload
      return {
        ...state,
        trucknotuseLoading: loading,
      }
    case LOAD_TRUCKNOTUSE.SUCCESS:
    case LOAD_TRUCKNOTUSE_PREVIEW.SUCCESS:
      return {
        ...state,
        trucknotusekUrl: action.payload.data.data,
        trucknotuseLoading: false,
      }
    case LOAD_VEHICLE_TRUCKNOTUSE.REQUEST:
      const { loading_vehicle } = action.payload
      return {
        ...state,
        trucknotuseLoading: loading_vehicle,
      }
    case LOAD_VEHICLE_TRUCKNOTUSE.SUCCESS:
      return {
        ...state,
        vehicleLists: action.payload.data.data,
        trucknotuseLoading: false,
      }
    case LOAD_VEHICLE_TYPE_TRUCKNOTUSE.SUCCESS:
      return {
        ...state,
        vehicleTypeLists: action.payload.data.data,
      }
    default:
      return state
  }
}
